<div class="aluno-card">
  <div class="header">
    <div class="col-md-1 icon">
      <mat-icon>school</mat-icon>
    </div>
    <div class="col-md-10 info">
      <h3 class="aluno-nome">{{nome}}</h3>
      <p>{{turma}}</p>
    </div>
    <span [ngClass]="{
      'ativa': (
        tipoDescricao === 'Matriculado' ||
        tipoDescricao === 'Remanejado' ||
        tipoDescricao === 'Transferido' ||
        tipoDescricao === 'Pre-Matricula'),
      'inativa': (tipoDescricao === 'Matricula Cancelada')
     }" class="col-md-2 status ativa">{{textoDescricao()}}</span>
  </div>

  <div class="details">
    <div class="details-grid">

    <div class="item">
      <mat-icon>calendar_today</mat-icon>
      <div>
        <label>Ano Letivo</label>
        <strong>{{periodo}}</strong>
      </div>
    </div>

    <div class="item">
      <mat-icon>account_circle</mat-icon>
      <div>
        <label>Responsável Financeiro</label>
        <strong>{{responsavel}}</strong>
      </div>
    </div>

    @if(statusFinanceiro){
      <div class="item">
        <mat-icon>attach_money</mat-icon>
        <div>
          <label>Status Financeiro</label>
          <strong [ngClass]="{
            'aviso': statusFinanceiro === 'Atrasado',
            'em-dia': statusFinanceiro === 'Em dia' || statusFinanceiro === 'Rematricula Paga',
            'pendente': statusFinanceiro === 'Pendente de Pagamento',
            'cancelada': statusFinanceiro === 'Cancelada',
            'erro': statusFinanceiro === 'Erro no Pagamento da Rematricula',
            'isento': statusFinanceiro === 'Isento'

          }">{{textoStatusPagamento()}}</strong>
        </div>
      </div>
    }

    <!-- <div class="item">
      <mat-icon>insights</mat-icon>
      <div>
        <label>Frequência</label>
        <strong>{{frequencia}}% de presença</strong>
      </div>
    </div> -->
  </div>
  <!-- </div> -->

  <!-- <div class="col-md-4"> -->
    <!-- <button class="btn detalhes-btn" color="primary">
      <mat-icon style="width: 50px;">visibility</mat-icon>
      Ver Detalhes
    </button> -->
  </div>
</div>
